<template>
    <div class="lang">
        <div class="info">
            <div class="table">
                <table>
                    <caption>RESULTS (Visit consultation, Postal consultation, View internet result)</caption>
                    <colgroup>
                        <col style="width: 25%">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th scope="row">Visit consultation</th>
                            <td class="left">
                                You may visit the Health Promotion Center at the time and date scheduled for a doctor's
                                consultation.<br>
                                We will connect you with the department related to the findings at consultation.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">E-Mail</th>
                            <td class="left">
                                The examination results will be sent to the e-mail address provided to the center about
                                two weeks after the examination.<br>
                                ※ The password for the examination result is 6 digits of the date of birth (YYMMDD).
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">View internet result</th>
                            <td class="left">
                                ※ The results of the medical examination after March 2, 2023 can be viewed on the KOREAN
                                website after the decision is completed. (Inquiries are available approximately two
                                weeks after the examination date.)<br>
                                ※ Please contact 02-6986-2222 for the results of the medical examination before February
                                28, 2023.<br>
                                ※ If you don't have a means of verifying your identity (mobile phone in your own name,
                                IPin etc.), please contact the Wellness Health Promotion Center. (e.g. Koreans or
                                foreigners residing abroad)
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>